import { render, staticRenderFns } from "./ContractProjectModal.vue?vue&type=template&id=53bd4eb4&scoped=true&"
import script from "./ContractProjectModal.vue?vue&type=script&lang=js&"
export * from "./ContractProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./ContractProjectModal.vue?vue&type=style&index=0&id=53bd4eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd4eb4",
  null
  
)

export default component.exports